import { IProduct } from "@interfaces";
import axiosClient from "./axiosClient";

export const productApi = {
  products: (params: IProduct) => {
    const url = "/product/get";
    return axiosClient.get(url, { params });
  },
  detail: (id: string) => {
    const url = `/admin/get/${id}`;
    return axiosClient.get(url);
  },
  create: (params: IProduct) => {
    const url = "/admin/create";
    return axiosClient.post(url, params);
  },
  update: (params: IProduct, id: string) => {
    const url = `/admin/update/${id}`;
    return axiosClient.put(url, params);
  },
};
